import {
    Modal,
    Button,
    Alert,
    connectModal,
    Checkbox,
} from '@gsa/afp-component-library';
import { useState } from 'react';

function AreqReminderModal({
    closeModal,
}) {
    const [checked, setChecked] = useState(false);

    const handleClose = () => {
        if (checked) {
            sessionStorage.setItem('ignoreAreqReminderModal', 'true');
        }
        closeModal();
    }

    return <Modal
        variant='large'
        onClose={closeModal}
        actions={
        <>
          <Button
            type="button"
            variant="primary"
            onClick={handleClose}
            label="Close"
          />
        </>
        }
    >
        <Alert type='warning'>
            <h1 style={{ margin: 0, padding: 0, fontSize: '24px', marginTop: '-12px' }}>Please be sure to...</h1>
            Type a complete description of your additional requirement and add supporting documents as needed.
            <ul style={{ margin: 0, paddingLeft: '12px', }}>
                <li><strong>DO NOT</strong> add supporting documents without entering a complete required description.</li>
                <li><strong>DO NOT</strong> type incomplete descriptions such as “See attached”</li>
            </ul>
        </Alert>
        <br />
        <Checkbox label="Do not show this message again" onChange={(e) => setChecked(e.target.checked)} />
    </Modal>
}

export default connectModal(AreqReminderModal);
